import type { TutorBillingRow } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useTutorBillingStore } from '../model/store'

export const useTutorBillingErase = async (billingId: number): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useTutorBillingStore()

  const url = useAdminRoutes('admin.tutors.billing.erase', { billing_id: billingId })

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    const { data } = await $axios.delete<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return false
    }

    const row: TutorBillingRow | undefined = data.data?.billing

    if (row) store.replaceRow(row)
    toast.success(data.message)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    store.setSaving(false)
  }
}
